import { SxProps, Theme } from "@mui/material";

export const accentGradient = "linear-gradient(90deg, #3b82f6 0%, #38bdf8 55%, #67e8f9 100%)";

export const gradientText: SxProps<Theme> = {
  background: accentGradient,
  WebkitBackgroundClip: "text",
  WebkitTextFillColor: "transparent",
  backgroundClip: "text",
};

export const eyebrow: SxProps<Theme> = {
  fontSize: "0.7rem",
  fontWeight: 600,
  letterSpacing: "0.18em",
  textTransform: "uppercase",
  color: "#38bdf8",
  fontFamily: "'Barlow', sans-serif",
  mb: 2,
};

export const ctaButton: SxProps<Theme> = {
  background: "linear-gradient(90deg, #f97316, #fb923c)",
  borderRadius: "50px",
  py: 1.5,
  px: 5,
  fontFamily: "'Barlow'",
  fontWeight: 700,
  textTransform: "none",
  color: "white",
  fontSize: "1rem",
  "&:hover": {
    background: "linear-gradient(90deg, #ea6c0a, #f97316)",
    color: "white",
  },
};

export const iconBox: SxProps<Theme> = {
  width: 40,
  height: 40,
  borderRadius: "10px",
  background: "rgba(56,189,248,0.1)",
  border: "1px solid rgba(56,189,248,0.2)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  flexShrink: 0,
};

export const featureRowCard: SxProps<Theme> = {
  display: "flex",
  flexDirection: "column",
  gap: 1.5,
  background: "rgba(255,255,255,0.04)",
  border: "1px solid rgba(56,189,248,0.1)",
  borderRadius: "14px",
  p: { xs: 2.5, md: 3 },
  backdropFilter: "blur(8px)",
};

export const featureRowTitle: SxProps<Theme> = {
  fontFamily: "'Poppins', sans-serif",
  fontWeight: 700,
  fontSize: "0.95rem",
  color: "#fff",
  mb: 0.5,
};

export const featureRowBody: SxProps<Theme> = {
  fontFamily: "'Barlow', sans-serif",
  fontSize: "0.88rem",
  color: "rgba(255,255,255,0.65)",
  lineHeight: 1.6,
};

export const heroSection: SxProps<Theme> = {
  background: "#040922",
  position: "relative",
  overflow: "hidden",
  minHeight: { xs: "90vh", md: "95vh" },
  display: "flex",
  alignItems: "center",
  textAlign: "center",
};

export const heroBackgroundImage: SxProps<Theme> = {
  position: "absolute",
  inset: 0,
  width: "100%",
  height: "100%",
  objectFit: "cover",
  objectPosition: "center",
  pointerEvents: "none",
};

export const heroRadialOverlay: SxProps<Theme> = {
  position: "absolute",
  inset: 0,
  background:
    "radial-gradient(ellipse 55% 65% at 50% 50%, rgba(4,9,34,0.82) 0%, rgba(4,9,34,0.55) 45%, rgba(4,9,34,0.18) 75%, rgba(4,9,34,0.08) 100%)",
  pointerEvents: "none",
};

export const heroGlowOverlay: SxProps<Theme> = {
  position: "absolute",
  inset: 0,
  background: "radial-gradient(ellipse 60% 50% at 50% 50%, rgba(56,189,248,0.06) 0%, transparent 65%)",
  pointerEvents: "none",
};

export const heroHeading: SxProps<Theme> = {
  fontFamily: "'Poppins', sans-serif",
  fontSize: { xs: "2.2rem", md: "3.2rem", lg: "3.8rem" },
  fontWeight: 800,
  letterSpacing: "-0.03em",
  lineHeight: 1.08,
  mb: 3,
  maxWidth: "820px",
  mx: "auto",
  color: "#fff",
};

export const heroSubheading: SxProps<Theme> = {
  fontSize: { xs: "1rem", md: "1.2rem" },
  color: "rgba(255,255,255,0.82)",
  maxWidth: "600px",
  mx: "auto",
  mb: 5,
  lineHeight: 1.7,
  fontFamily: "'Barlow', sans-serif",
};

export const heroBottomGradient: SxProps<Theme> = {
  position: "absolute",
  bottom: 0,
  left: 0,
  right: 0,
  height: "180px",
  background: "linear-gradient(to bottom, transparent 0%, #040922 100%)",
  pointerEvents: "none",
  zIndex: 2,
};

export const buildOrSellSection: SxProps<Theme> = {
  background: "linear-gradient(to bottom, #040922 0%, #080f1e 100%)",
  py: { xs: 12, md: 18 },
};

export const sectionHeading: SxProps<Theme> = {
  fontFamily: "'Poppins', sans-serif",
  fontSize: { xs: "2rem", md: "3rem" },
  fontWeight: 800,
  letterSpacing: "-0.02em",
  lineHeight: 1.1,
  color: "#fff",
};

export const buildOrSellCardTitle: SxProps<Theme> = {
  fontFamily: "'Poppins', sans-serif",
  fontWeight: 800,
  fontSize: { xs: "1.5rem", md: "1.8rem" },
  color: "white",
  letterSpacing: "-0.01em",
};

export const verticalDivider: SxProps<Theme> = {
  display: { xs: "none", md: "block" },
  width: "1px",
  background:
    "linear-gradient(to bottom, transparent, rgba(56,189,248,0.25) 20%, rgba(56,189,248,0.25) 80%, transparent)",
  flexShrink: 0,
  mx: 5,
};

export const horizontalDivider: SxProps<Theme> = {
  display: { xs: "block", md: "none" },
  height: "1px",
  background:
    "linear-gradient(to right, transparent, rgba(56,189,248,0.25) 30%, rgba(56,189,248,0.25) 70%, transparent)",
};

export const whyChooseHeading: SxProps<Theme> = {
  fontFamily: "'Poppins', sans-serif",
  fontWeight: 800,
  fontSize: { xs: "2rem", md: "3rem", lg: "3.6rem" },
  color: "white",
  letterSpacing: "-0.02em",
  lineHeight: 1.1,
  mb: 3,
};

export const whyChooseBody: SxProps<Theme> = {
  fontFamily: "'Barlow', sans-serif",
  fontSize: { xs: "1rem", md: "1.1rem" },
  color: "rgba(255,255,255,0.65)",
  lineHeight: 1.75,
  maxWidth: "600px",
  mb: { xs: 8, md: 10 },
};

export const statBorderBox: SxProps<Theme> = {
  pt: 3,
  pr: { xs: 0, sm: 4 },
  borderTop: "1px solid rgba(59,130,246,0.25)",
};

export const statValue: SxProps<Theme> = {
  fontSize: { xs: "2.8rem", md: "3.4rem" },
  fontWeight: 800,
  lineHeight: 1,
  mb: 0.75,
  background: "linear-gradient(90deg, #3b82f6 0%, #38bdf8 55%, #67e8f9 100%)",
  WebkitBackgroundClip: "text",
  WebkitTextFillColor: "transparent",
  backgroundClip: "text",
  fontFamily: "'Poppins', sans-serif",
};

export const statLabel: SxProps<Theme> = {
  fontSize: "0.7rem",
  fontWeight: 700,
  letterSpacing: "0.15em",
  textTransform: "uppercase",
  color: "white",
  mb: 0.5,
  fontFamily: "'Barlow', sans-serif",
};

export const statDescription: SxProps<Theme> = {
  fontSize: "0.85rem",
  color: "rgba(255,255,255,0.55)",
  lineHeight: 1.55,
  fontFamily: "'Barlow', sans-serif",
};

export const getStartedButton: SxProps<Theme> = {
  background: "linear-gradient(90deg, #f97316, #fb923c)",
  color: "white",
  borderRadius: "50px",
  px: 5,
  py: 1.5,
  fontSize: "1rem",
  fontWeight: 700,
  fontFamily: "'Barlow', sans-serif",
  textTransform: "none",
  boxShadow: "0 4px 24px rgba(249,115,22,0.3)",
  "&:hover": { background: "linear-gradient(90deg, #ea6c0a, #f97316)", color: "white" },
};

export const whyPartnerSection: SxProps<Theme> = {
  py: { xs: 12, md: 18 },
  background: "linear-gradient(to bottom, #080f1e 0%, #040922 100%)",
  position: "relative",
  overflow: "hidden",
};

export const whyPartnerHeading: SxProps<Theme> = {
  fontFamily: "'Poppins', sans-serif",
  fontWeight: 800,
  fontSize: { xs: "2.2rem", md: "3.2rem", lg: "3.8rem" },
  color: "white",
  letterSpacing: "-0.02em",
  lineHeight: 1.12,
};

export const whyPartnerGrid: SxProps<Theme> = {
  display: { xs: "flex", md: "grid" },
  flexDirection: { xs: "column", md: "unset" },
  gridTemplateColumns: { md: "repeat(3, 1fr)" },
  gridTemplateRows: { md: "repeat(4, minmax(320px, auto))" },
  gridTemplateAreas: {
    md: `"photoA  copy1   photoB"
         "photoA  copy1   copy2 "
         "photoC  copy3   photoD"
         "copy4   copy5   photoE"`,
  },
  width: "100%",
};

export const whyPartnerCopyIconBox: SxProps<Theme> = {
  width: 44,
  height: 44,
  borderRadius: "12px",
  background: "rgba(56,189,248,0.1)",
  border: "1px solid rgba(56,189,248,0.2)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  mb: 3,
  flexShrink: 0,
  "& svg": { fontSize: 22, color: "#38bdf8" },
};

export const whyPartnerCopyTitle: SxProps<Theme> = {
  fontFamily: "'Poppins', sans-serif",
  fontWeight: 700,
  fontSize: { xs: "1.3rem", lg: "1.6rem" },
  color: "white",
  mb: 2,
  lineHeight: 1.25,
};

export const whyPartnerCopyBody: SxProps<Theme> = {
  fontFamily: "'Barlow', sans-serif",
  fontSize: "0.95rem",
  color: "rgba(255,255,255,0.65)",
  lineHeight: 1.75,
};

export const whyPartnerPhoto: SxProps<Theme> = {
  position: "absolute",
  inset: 0,
  width: "100%",
  height: "100%",
  objectFit: "cover",
  objectPosition: "center",
  display: "block",
};

export const whyPartnerPhotoOverlay: SxProps<Theme> = {
  position: "absolute",
  inset: 0,
  background: "linear-gradient(to bottom, rgba(4,9,34,0.1) 0%, rgba(4,9,34,0.35) 100%)",
  pointerEvents: "none",
};

export const becomePartnerSection: SxProps<Theme> = {
  py: { xs: 12, md: 18 },
  background: "linear-gradient(to bottom, #040922 0%, #080f1e 55%, #040922 100%)",
  position: "relative",
  overflow: "hidden",
};

export const becomePartnerGlow: SxProps<Theme> = {
  position: "absolute",
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  background: "radial-gradient(ellipse 70% 60% at 50% 50%, rgba(56,189,248,0.06) 0%, transparent 70%)",
  pointerEvents: "none",
};

export const becomePartnerHeading: SxProps<Theme> = {
  fontFamily: "'Poppins', sans-serif",
  fontWeight: 800,
  fontSize: { xs: "2.2rem", md: "3.2rem", lg: "3.8rem" },
  color: "white",
  letterSpacing: "-0.02em",
  lineHeight: 1.12,
  mb: 3,
};

export const becomePartnerBody: SxProps<Theme> = {
  fontFamily: "'Barlow', sans-serif",
  fontSize: { xs: "1rem", md: "1.1rem" },
  color: "rgba(255,255,255,0.7)",
  lineHeight: 1.75,
  maxWidth: "600px",
  mx: "auto",
};

export const requirementCardGlow: SxProps<Theme> = {
  position: "absolute",
  top: -40,
  left: -40,
  width: 160,
  height: 160,
  borderRadius: "50%",
  background: "radial-gradient(circle, rgba(56,189,248,0.09) 0%, transparent 70%)",
  pointerEvents: "none",
};

export const requirementIconBox: SxProps<Theme> = {
  width: 44,
  height: 44,
  borderRadius: "12px",
  background: "rgba(56,189,248,0.1)",
  border: "1px solid rgba(56,189,248,0.2)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  mb: 2.5,
  "& svg": { fontSize: 22, color: "#38bdf8" },
};

export const requirementTitle: SxProps<Theme> = {
  fontFamily: "'Poppins', sans-serif",
  fontWeight: 700,
  fontSize: "1rem",
  color: "white",
  mb: 1.5,
};

export const requirementBody: SxProps<Theme> = {
  fontFamily: "'Barlow', sans-serif",
  fontSize: "0.92rem",
  color: "rgba(255,255,255,0.6)",
  lineHeight: 1.65,
};

export const testimonialsSection: SxProps<Theme> = {
  py: { xs: 10, md: 16 },
  background: "linear-gradient(to bottom, #040922, #080f1e 50%, #040922)",
  overflow: "hidden",
};

export const testimonialsHeading: SxProps<Theme> = {
  fontFamily: "'Poppins', sans-serif",
  fontWeight: 800,
  fontSize: { xs: "2.2rem", md: "3rem", lg: "3.6rem" },
  color: "white",
  lineHeight: 1.15,
};

export const testimonialNavButton: SxProps<Theme> = {
  position: "absolute",
  top: "50%",
  transform: "translateY(-50%)",
  zIndex: 10,
  width: 48,
  height: 48,
  bgcolor: "rgba(5,12,35,0.7)",
  border: "1px solid rgba(59,130,246,0.3)",
  backdropFilter: "blur(8px)",
  color: "#38bdf8",
  "&:hover": { bgcolor: "rgba(59,130,246,0.2)", borderColor: "rgba(59,130,246,0.6)" },
  transition: "all 0.2s ease",
};

export const testimonialCarouselTrack: SxProps<Theme> = {
  display: "flex",
  gap: "24px",
  alignItems: "center",
};

export const testimonialCardInner: SxProps<Theme> = {
  background: "rgba(5,12,35,0.55)",
  backdropFilter: "blur(16px)",
  border: "1px solid rgba(59,130,246,0.4)",
  borderRadius: "20px",
  overflow: "hidden",
  boxShadow: "0 24px 80px rgba(0,0,0,0.5), 0 0 60px rgba(59,130,246,0.12)",
  p: { xs: 4, md: 5 },
};

export const testimonialQuoteIcon: SxProps<Theme> = {
  fontSize: 40,
  color: "rgba(56,189,248,0.3)",
  mb: 2,
  display: "block",
};

export const testimonialQuoteText: SxProps<Theme> = {
  fontFamily: "'Barlow', sans-serif",
  color: "rgba(255,255,255,0.82)",
  fontSize: "1rem",
  lineHeight: 1.75,
  fontStyle: "italic",
  mb: 4,
};

export const testimonialAvatarCircle: SxProps<Theme> = {
  width: 44,
  height: 44,
  borderRadius: "50%",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  flexShrink: 0,
};

export const testimonialName: SxProps<Theme> = {
  color: "white",
  fontWeight: 700,
  fontSize: "0.95rem",
  fontFamily: "'Barlow', sans-serif",
};

export const testimonialRole: SxProps<Theme> = {
  color: "rgba(255,255,255,0.45)",
  fontSize: "0.8rem",
  fontFamily: "'Barlow', sans-serif",
};

export const whyPowurSection: SxProps<Theme> = {
  background: "#040922",
  py: { xs: 12, md: 18 },
  overflow: "hidden",
};

export const whyPowurHeading: SxProps<Theme> = {
  fontFamily: "'Poppins', sans-serif",
  fontWeight: 800,
  fontSize: { xs: "2.2rem", md: "3.2rem", lg: "3.8rem" },
  color: "white",
  letterSpacing: "-0.02em",
  lineHeight: 1.12,
  mb: 4,
};

export const whyPowurQuoteWrapper: SxProps<Theme> = {
  display: "flex",
  alignItems: "flex-start",
  justifyContent: "center",
  gap: 1.5,
  maxWidth: "700px",
  mx: "auto",
};

export const whyPowurQuoteText: SxProps<Theme> = {
  fontFamily: "'Poppins', sans-serif",
  fontWeight: 500,
  fontSize: { xs: "1rem", md: "1.15rem" },
  fontStyle: "italic",
  color: "rgba(255,255,255,0.75)",
  lineHeight: 1.7,
  textAlign: "left",
};

export const whyPowurQuoteAttribution: SxProps<Theme> = {
  display: "block",
  mt: 1.5,
  fontStyle: "normal",
  fontWeight: 600,
  fontSize: "0.85rem",
  color: "#38bdf8",
};

export const whyPowurScrollContainer: SxProps<Theme> = {
  px: { xs: 2, md: 4 },
  overflowX: { xs: "auto", lg: "visible" },
  pb: 2,
  "&::-webkit-scrollbar": { height: 4 },
  "&::-webkit-scrollbar-track": { background: "rgba(255,255,255,0.05)", borderRadius: 2 },
  "&::-webkit-scrollbar-thumb": { background: "rgba(56,189,248,0.3)", borderRadius: 2 },
};

export const whyPowurCardTrack: SxProps<Theme> = {
  display: "flex",
  gap: 2.5,
  minWidth: { xs: "max-content", lg: "unset" },
  maxWidth: "1400px",
  mx: "auto",
};

export const whyPowurCardImageWrapper: SxProps<Theme> = {
  position: "relative",
  aspectRatio: "4/3",
  overflow: "hidden",
};

export const whyPowurCardImage: SxProps<Theme> = {
  position: "absolute",
  inset: 0,
  width: "100%",
  height: "100%",
  objectFit: "cover",
  objectPosition: "center",
  display: "block",
  transition: "transform 0.5s ease",
};

export const whyPowurCardImageOverlay: SxProps<Theme> = {
  position: "absolute",
  inset: 0,
  background: "linear-gradient(to bottom, rgba(4,9,34,0.05) 0%, rgba(4,9,34,0.4) 100%)",
  pointerEvents: "none",
};

export const whyPowurCardTitle: SxProps<Theme> = {
  fontFamily: "'Poppins', sans-serif",
  fontWeight: 700,
  fontSize: { xs: "0.98rem", md: "0.85rem" },
  color: "white",
  mb: 1,
  lineHeight: 1.3,
  whiteSpace: { lg: "nowrap" },
};

export const whyPowurCardBody: SxProps<Theme> = {
  fontFamily: "'Barlow', sans-serif",
  fontSize: "0.88rem",
  color: "rgba(255,255,255,0.55)",
  lineHeight: 1.65,
};

export const powurPlatformSection: SxProps<Theme> = {
  background: "linear-gradient(to bottom, #040922 0%, #080f1e 60%, #040922 100%)",
  py: { xs: 12, md: 18 },
};

export const powurPlatformSidebar: SxProps<Theme> = {
  flex: { md: "0 0 300px", lg: "0 0 340px" },
  textAlign: "left",
  position: { md: "sticky" },
  top: { md: "120px" },
};

export const powurPlatformHeading: SxProps<Theme> = {
  fontFamily: "'Poppins', sans-serif",
  fontWeight: 800,
  fontSize: { xs: "2.2rem", md: "2.6rem", lg: "3.2rem" },
  color: "white",
  letterSpacing: "-0.02em",
  lineHeight: 1.12,
  mb: 3,
};

export const powurPlatformBody: SxProps<Theme> = {
  fontFamily: "'Barlow', sans-serif",
  color: "rgba(255,255,255,0.65)",
  fontSize: "1.05rem",
  lineHeight: 1.7,
};

export const platformFeatureImageWrapper: SxProps<Theme> = {
  width: "100%",
  overflow: "hidden",
  background: "#f0f4fa",
  flexShrink: 0,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
};

export const platformFeatureImage: SxProps<Theme> = {
  width: "100%",
  height: "auto",
  display: "block",
  transition: "transform 0.4s ease",
  "&:hover": { transform: "scale(1.02)" },
};

export const platformFeatureGlow: SxProps<Theme> = {
  position: "absolute",
  top: -50,
  left: -50,
  width: 180,
  height: 180,
  borderRadius: "50%",
  background: "radial-gradient(circle, rgba(56,189,248,0.09) 0%, transparent 70%)",
  pointerEvents: "none",
};

export const platformFeatureIconBox: SxProps<Theme> = {
  width: 44,
  height: 44,
  borderRadius: "12px",
  background: "rgba(56,189,248,0.1)",
  border: "1px solid rgba(56,189,248,0.2)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  mb: 3,
  "& svg": { fontSize: 22, color: "#38bdf8" },
};

export const platformFeatureTitle: SxProps<Theme> = {
  fontFamily: "'Poppins', sans-serif",
  fontWeight: 700,
  fontSize: "1.05rem",
  color: "white",
  mb: 1.5,
};

export const platformFeatureBody: SxProps<Theme> = {
  fontFamily: "'Barlow', sans-serif",
  fontSize: "0.95rem",
  color: "rgba(255,255,255,0.65)",
  lineHeight: 1.7,
};

export const ctaSection: SxProps<Theme> = {
  background: "#040922",
  minHeight: { xs: "80vh", md: "92vh" },
  display: "flex",
  alignItems: "center",
  textAlign: "left",
  position: "relative",
  overflow: "hidden",
};

export const ctaBackgroundImage: SxProps<Theme> = {
  position: "absolute",
  inset: 0,
  width: "100%",
  height: "100%",
  objectFit: "cover",
  objectPosition: "center top",
  pointerEvents: "none",
};

export const ctaLeftGradient: SxProps<Theme> = {
  position: "absolute",
  inset: 0,
  background:
    "linear-gradient(to right, rgba(4,9,34,0.96) 0%, rgba(4,9,34,0.82) 45%, rgba(4,9,34,0.3) 75%, rgba(4,9,34,0.1) 100%)",
  pointerEvents: "none",
};

export const ctaTopGradient: SxProps<Theme> = {
  position: "absolute",
  top: 0,
  left: 0,
  right: 0,
  height: "200px",
  background: "linear-gradient(to bottom, #040922 0%, transparent 100%)",
  pointerEvents: "none",
  zIndex: 1,
};

export const ctaHeading: SxProps<Theme> = {
  fontFamily: "'Poppins', sans-serif",
  fontWeight: 700,
  fontSize: { xs: "1.6rem", md: "2.4rem", lg: "3rem" },
  color: "white",
  lineHeight: 1.3,
  mb: 6,
  letterSpacing: "-0.02em",
};

export const ctaBadgeRow: SxProps<Theme> = {
  display: "flex",
  flexWrap: "wrap",
  gap: 2,
  mb: 5,
};

export const ctaBadgeImage: SxProps<Theme> = {
  height: { xs: 44, md: 56 },
  width: "auto",
  objectFit: "contain",
  opacity: 0.8,
  "&:hover": { opacity: 1 },
  transition: "opacity 0.2s ease",
};

export const featureGrid: SxProps<Theme> = {
  display: "grid",
  gridTemplateColumns: "1fr 1fr",
  gap: 2,
};
